function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n   height: 246px;\n   display: flex;\n   align-items: center;\n\n   & h1 {\n      font-family: SharpSansSemiBold, sans-serif;\n      font-size: 2rem;\n      color: ", ";\n      margin-bottom: 0;\n   }\n\n   & p {\n      color: ", ";\n      display: inline-block;\n      margin-bottom: 15px;\n   }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   background-color: ", ";\n   background-image: radial-gradient(\n      circle,\n      ", " 0%,\n      ", "\n         89%\n   );\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React from 'react';
import styled from 'styled-components';
import { darken, saturate } from 'polished';
import { InnerContentWrapper } from './InnerContentWrapper';
var Outer = styled.header(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.semanticColors.primary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.semanticColors.primary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return saturate(0.12, darken(0.16, theme.semanticColors.primary));
});
var Inner = styled.div(_templateObject2(), function (_ref4) {
  var theme = _ref4.theme;
  return theme.brandColors.white;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.brandColors.white;
});

var PageHeader = function PageHeader(_ref6) {
  var title = _ref6.title,
      subtitle = _ref6.subtitle;
  return /*#__PURE__*/React.createElement(Outer, null, /*#__PURE__*/React.createElement(Inner, null, /*#__PURE__*/React.createElement(InnerContentWrapper, null, /*#__PURE__*/React.createElement("h1", null, title), /*#__PURE__*/React.createElement("p", null, subtitle))));
};

export { PageHeader };